module.exports = __webpack_public_path__ + "static/bg.72cba2e8.png";